@if (link) {
  <a [kbRouterOrExternalLink]="link.href" [attr.target]="link.target" class="container link">
    <ng-container [ngTemplateOutlet]="contentTemplate" />
  </a>
} @else {
  <div class="container">
    <ng-container [ngTemplateOutlet]="contentTemplate" />
  </div>
}

<ng-template #contentTemplate>
  <ng-content/>
  <div class="overlay overlay--top">
    <ng-content select="[kb-chip],kb-chip" />
  </div>
  @if (heading || abstract) {
    <div class="overlay overlay--bottom">
      <div class="text">
        @if (heading) {
          <kb-variable-heading class="heading" [level]="headingLevel">
            <kb-line-clamp [attr.lines]="headingLines" [class.with-icon]="linkIcon && link && (!abstract || abstractMode === 'button')">
              {{heading}}
            </kb-line-clamp>
            @if (linkIcon && link && (!abstract || abstractMode === 'button')) {
              <kb-icon [icon]="linkIcon" />
            }
          </kb-variable-heading>
        }
        @if (abstract && abstractMode === 'visible') {
          <p kb-paragraph>
            <kb-line-clamp [attr.lines]="abstractLines" [class.with-icon]="linkIcon && link">
              {{abstract}}
            </kb-line-clamp>
            @if (linkIcon && link) {
              <kb-icon [icon]="linkIcon" />
            }
          </p>
        }
      </div>
      @if (abstractMode === 'button' && abstract) {
        <!-- todo: accessibility -->
        <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
        <button class="abstract-button" type="button" kb-icon icon-uppercase icon-center [icon]="captionOpen ? iconCloseCaption : iconOpenCaption" (click)="captionOpen ? closeCaption($event) : openCaption($event)"></button>
      }
    </div>
  }
</ng-template>
@if (abstractMode === 'button' && abstract) {
  <figcaption class="caption" [class.visible]="captionOpen">
    <p kb-paragraph>
      {{ abstract }}
    </p>
  </figcaption>
}
